module.exports = __webpack_public_path__ + "static/media/SAP graphic.e845b0d9.svg";